/** * 系统管理 用户管理 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!--列表-->
    <el-table
      size="small"
      :data="userData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%;margin-top:20px;"
    >
      <el-table-column align="center" sortable prop="id" label="ID" width="100">
      </el-table-column>
      <el-table-column align="center" prop="username" label="用户名">
      </el-table-column>
      <el-table-column align="center" label="注册邮箱">
        <template slot-scope="scope">
          <div>{{ scope.row.email ? scope.row.email : "-" }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" sortable prop="editTime" label="注册时间">
        <template slot-scope="scope">
          <div>{{ scope.row.regtime | timestampToTime }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column
        align="center"
        sortable
        prop="editTime"
        label="最近登录时间"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.lastlogintime | timestampToTime }}</div>
        </template>
      </el-table-column> -->
      <el-table-column align="center" sortable prop="userSex" label="使用时长">
        <template slot-scope="scope">
          <div>{{ dealTime(scope.row.regtime | timestampToTime) }}天</div>
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" sortable prop="orderNums" label="包裹量">
      </el-table-column> -->
      <!-- <el-table-column>
       <template slot-scope="scope">
       <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button> </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
  </div>
</template>

<script>
// 导入请求方法
import { userList } from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      loading: false, //是显示加载
      title: "添加用户",
      // 请求数据参数
      formInline: {
        page: 1,
        limit: 10
      },
      //用户数据
      userData: [],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    };
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    dealTime(time) {
      let now = new Date().getTime();
      now = parseInt(now / 1000);
      let day = parseInt((now - time) / (60 * 60 * 24));
      return day;
    },
    // 获取数据方法
    getdata(parameter) {
      this.loading = true;

      // 获取用户列表
      userList(parameter).then(res => {
        this.loading = false;
        if (res.success == false) {
          this.$message({
            type: "info",
            message: res.msg
          });
        } else {
          this.userData = res.data.userList;
          // 分页赋值
          this.pageparm.currentPage = res.data.currentPage;
          this.pageparm.pageSize = res.data.onePageCount;
          this.pageparm.total = res.data.totalCount;
        }
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata(this.formInline);
    },

    // 删除用户
    deleteUser(index, row) {
      this.$confirm("确定要删除该用户吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // 删除
          userDelete(row.id)
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "用户已删除!"
                });
                this.getdata(this.formInline);
                this.returnPage();
              } else {
                this.$message({
                  type: "info",
                  message: res.msg
                });
              }
            })
            .catch(err => {
              this.loading = false;
              this.$message.error("用户删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除！"
          });
        });
    }
  }
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/system/user.vue